import { useEffect, useState, useRef } from 'react'
import { View } from "base/src/components/Basic/View/view"

import { RootStateBase } from '../../../store/baseStore';

import * as S from './styles'
import { Button } from '../../../components/Button';
import { Icon } from '@iconify/react';
import { Row } from '../../../components/Basic/Row/row';
import { SUCCESS_REMOVE } from 'domain/types/base/base';
import { AppThunk } from '../../../utils/reducerUtil';
import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';

function CloseSuccess(successIndex: number): AppThunk {
    return async (dispatch) => {
        dispatch({
            payload: successIndex,
            type: SUCCESS_REMOVE
        });
    };
}

const connector = connectUtil(
  (state: RootStateBase) => ({
    success: state.BaseReducer.Success,
  }),
  { CloseSuccess }
);

export interface ErrorProps extends PropsFromRedux<typeof connector> {
    stateNames: string[]
}

function Success(props: ErrorProps){
    const successIndex = props.success.findIndex((e) => props.stateNames.includes(e.Name));
    const success = props.success.find((e) => props.stateNames.includes(e.Name));
    
    const callBackText = typeof success?.CallBack !== 'function' ? success?.CallBack?.CallBackText : "Ok!";


    function handleClick(){
        if (typeof success?.CallBack === 'function') {
            success.CallBack();
        }else{
            success?.CallBack.CallBack();
        }
        if(success != null)
        props.CloseSuccess(successIndex);
    }



    const [size, setSize] = useState<{ w: number, h: number }>()
    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (ref && ref.current) {
            setSize({ w: ref.current.clientWidth, h: ref.current.clientHeight })
        }
    },[])

    return (

        props.success.find((e) => props.stateNames.includes(e.Name)) &&
        <S.Sucess ref={ref} className='fullCenter'>
            <Row className='fullCenter'>
                <S.SucessText>
                    {success &&
                        <View>{success.Message}</View>
                    }
                </S.SucessText>
                <S.SucessText>
                    <Button style={{maxHeight:size?.h}} onClick={handleClick} type='button' iconPosition='left' size='xsm' >
                        <Icon icon="mdi-refresh" height="18px" color={"white"} />
                        {callBackText}
                    </Button>
                </S.SucessText>
            </Row>
        </S.Sucess>


    )
}

export default connector(Success);
